export default function ContentArea(props) {
  return (
    <div
      className={`h-full w-full flex-grow mx-auto bg-skin-fill-body-light dark:bg-skin-fill-body-dark ${props.classes}`}
    >
      {props.children}
    </div>
  );
}
